import { clsx } from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
}

export function Card({ children, className, title, action }: Props) {
  return (
    <div className={clsx('bg-white dark:bg-[#111] rounded-lg shadow-sm border border-gray-200 dark:border-gray-800', className)}>
      {title && (
        <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h3>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

interface StatCardProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  color?: 'purple' | 'green' | 'red' | 'blue' | 'yellow' | 'teal' | 'gray';
  selected?: boolean;
}

const colorMap = {
  purple: 'bg-purple-50 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400',
  green: 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400',
  red: 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400',
  blue: 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400',
  yellow: 'bg-yellow-50 text-yellow-700 dark:bg-yellow-900/20 dark:text-yellow-400',
  teal: 'bg-teal-50 text-teal-700 dark:bg-teal-900/20 dark:text-teal-400',
  gray: 'bg-gray-50 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
};

export function StatCard({ label, value, icon, color = 'gray', selected }: StatCardProps) {
  return (
    <div className={clsx('rounded-lg px-3 py-2', colorMap[color], selected && 'ring-2 ring-offset-1 ring-purple-500 dark:ring-purple-400 dark:ring-offset-gray-900')}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-medium opacity-75">{label}</p>
          <p className="text-lg font-bold">{value}</p>
        </div>
        {icon && <div className="opacity-50">{icon}</div>}
      </div>
    </div>
  );
}
